import React from 'react';

function Aboutus(props) {

    return (
        <div>
            <div className='about-us-section'>
                <div className='about-text'>
                Looking for the best WiFi connection in your area in perambalur? Go 100% fibre-optic and experience the WiFi speed and reliability your home deserves. Switch to Zerone Fibernet today!
                </div>
            </div>
        </div>
    );
}


export default Aboutus;
